import {
    Button,
    ButtonGroup,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core"
import { Add, Delete, Remove } from "@material-ui/icons"
import { useMemo, useState } from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import useParametros from "../../../contexts/ParametrosContext"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { EditarPedidoMesa, ExcluirItemDoPedidoMesa } from "../../../services/integracao"
import useLoadingStore from "../../../stores/LoadingStore"

const CardPedido = ({
    alertStart,
    pedidoEnviar,
    classes,
    index,
    mesa,
    setMesaRenderizar,
    atualizarMesas,
}) => {
    const history = useHistory()
    const parametros = useParametros()
    const autorizacao = localStorage.getItem("chaveSistema")
    const EXIBIR_DELETE = !parametros.PUBLIC_NAO_PERMITIR_DELETAR_ITEM_MESA
    const setLoading = useLoadingStore(s => s.setLoading)

    const [itens, setItens] = useState(pedidoEnviar?.itens)
    const [dialogExcluir, setDialogExcluir] = useState(false)
    const [dialogAdicionar, setDialogAdicionar] = useState(false)
    const [itemExcluir, setItemExcluir] = useState()
    const [itemAdicionar, setItemAdicionar] = useState()
    const [qtdAdicionar, setQtdAdicionar] = useState(1)
    const [obsAdicionar, setObsAdicionar] = useState("")

    const abrirDialogAdicionar = item => {
        setItemAdicionar(item)
        setQtdAdicionar(1)
        setObsAdicionar(item?.observacao ?? "")
        setDialogAdicionar(true)
    }

    const fecharDialogAdicionar = () => {
        setDialogAdicionar(false)
    }

    const calcularTotalPedido = lista =>
        (lista ?? []).reduce((acc, i) => acc + (Number(i?.valorProdutoHistorico) || 0), 0)

    const resumo = useMemo(() => {
        const totalItens = (itens ?? []).reduce((acc, i) => acc + (i?.quantidade ?? 0), 0)
        const valorTotalProdutos = (itens ?? []).reduce(
            (acc, i) => acc + (i?.valorProdutoHistorico ?? 0),
            0
        )
        return { totalItens, valorTotalProdutos }
    }, [itens])

    const formatBRL = v =>
        Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v ?? 0)

    const recalcularItem = (i, qtd) => {
        const qtdAtual = i?.quantidade ?? 0
        const novaQtd = qtdAtual + qtd

        const totalAtual = i?.valorProdutoHistorico ?? 0
        const precoUnit = qtdAtual > 0 ? totalAtual / qtdAtual : 0

        return {
            ...i,
            quantidade: novaQtd,
            valorProdutoHistorico: precoUnit * novaQtd,
        }
    }

    const handleToggleDialogExcluir = () => {
        setDialogExcluir(prev => !prev)
    }

    const handleExcluirItem = async item => {
        setLoading(true)
        const qtdAtual = item.quantidade ?? 0
        const precoUnit = qtdAtual > 0 ? (item.valorProdutoHistorico ?? 0) / qtdAtual : 0

        const data = {
            id: item.id,
            produto: { id: item.produto.id },
            quantidade: qtdAtual - 1,
            valorProdutoHistorico: precoUnit * (qtdAtual - 1),
        }

        try {
            if (pedidoEnviar?.itens.length === 1 && item.quantidade === 1) {
                throw new Error(
                    "Não é permitido excluir um produto de um pedido que possui apenas um item; a operação recomendada é fechar a mesa."
                )
            } else if (data.quantidade >= 1) {
                handleToggleDialogExcluir()
                const sucesso = await editarPedidoMesa(pedidoEnviar, data)
                if (sucesso) {
                    const itensAtualizados = itens.map(i =>
                        i.id === data.id ? recalcularItem(i, -1) : i
                    )
                    setItens(itensAtualizados)

                    const novoTotalPedido = calcularTotalPedido(itensAtualizados)

                    setMesaRenderizar(prevMesa => ({
                        ...prevMesa,
                        pedidosMesa: (prevMesa?.pedidosMesa ?? []).map(p =>
                            p.id === pedidoEnviar.id
                                ? { ...p, valorTotal: novoTotalPedido, itens: itensAtualizados }
                                : p
                        ),
                    }))
                    atualizarMesas()
                    alertStart("Item removido com sucesso", "success")
                } else {
                    alertStart("Erro ao remover item", "error")
                }
            } else {
                await excluirItemDoPedidoMesa()
                handleToggleDialogExcluir()
            }
        } catch (error) {
            alertStart(error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    const handleAdicionarItem = async (item, qtd = 1, observacao = "") => {
        setLoading(true)
        const qtdAtual = item.quantidade ?? 0
        const precoUnit = qtdAtual > 0 ? (item.valorProdutoHistorico ?? 0) / qtdAtual : 0

        const novaQtd = qtdAtual + qtd

        const data = {
            id: item.id,
            produto: { id: item.produto.id },
            quantidade: novaQtd,
            valorProdutoHistorico: precoUnit * novaQtd,
            observacao: observacao.trim(),
        }

        try {
            fecharDialogAdicionar()
            const sucesso = await editarPedidoMesa(pedidoEnviar, data)

            if (sucesso) {
                const itensAtualizados = itens.map(i =>
                    i.id === data.id ? recalcularItem(i, +qtd) : i
                )
                setItens(itensAtualizados)

                const novoTotalPedido = calcularTotalPedido(itensAtualizados)

                setMesaRenderizar(prevMesa => ({
                    ...prevMesa,
                    pedidosMesa: (prevMesa?.pedidosMesa ?? []).map(p =>
                        p.id === pedidoEnviar.id
                            ? { ...p, valorTotal: novoTotalPedido, itens: itensAtualizados }
                            : p
                    ),
                }))

                atualizarMesas()
                alertStart("Item adicionado com sucesso", "success")
            } else {
                alertStart("Erro ao adicionar item", "error")
            }
        } catch (error) {
            alertStart(error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    const excluirItemDoPedidoMesa = async () => {
        setLoading(true)
        try {
            const response = await ExcluirItemDoPedidoMesa(
                itemExcluir.id,
                pedidoEnviar,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const itensAtualizados = itens.filter(p => p.id !== itemExcluir.id)
            setItens(itensAtualizados)

            const novoTotalPedido = calcularTotalPedido(itensAtualizados)

            setMesaRenderizar(prevMesa => ({
                ...prevMesa,
                pedidosMesa: (prevMesa?.pedidosMesa ?? []).map(p =>
                    p.id === pedidoEnviar.id
                        ? { ...p, valorTotal: novoTotalPedido, itens: itensAtualizados }
                        : p
                ),
            }))
            alertStart("Item excluído com sucesso", "success")
        } catch (error) {
            RegistrarLogErro(error, "excluirItemDoPedidoMesa")
            alertStart(`Procure os desenvolvedores! Erro: ${error.message}`, "error")
        } finally {
            setLoading(false)
        }
    }

    const editarPedidoMesa = async (pedido, data) => {
        setLoading(true)
        try {
            const response = await EditarPedidoMesa(pedido.id, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            return true
        } catch (error) {
            RegistrarLogErro(error, "editarPedidoMesa")
            alertStart(`Procure os desenvolvedores! Erro: ${error.message}`, "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Dialog open={dialogExcluir} onClose={handleToggleDialogExcluir}>
                <DialogTitle>Confirmação de exclusão</DialogTitle>
                <DialogContent>
                    <Typography>
                        Essa operação é irreversível, tem certeza que deseja{" "}
                        <span style={{ fontWeight: "bold" }}>excluir</span> esse item?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{ color: "white", backgroundColor: "#dc3545" }}
                        onClick={handleToggleDialogExcluir}
                    >
                        Cancelar
                    </Button>
                    <Button
                        style={{ color: "white", backgroundColor: "#28a745" }}
                        onClick={() => {
                            handleExcluirItem(itemExcluir)
                        }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialogAdicionar} onClose={fecharDialogAdicionar} fullWidth maxWidth="xs">
                <DialogTitle>Adicionar item</DialogTitle>

                <DialogContent>
                    <Typography style={{ fontWeight: "bold", marginBottom: 8 }}>
                        {itemAdicionar?.produto?.nome}
                    </Typography>

                    <Typography style={{ textAlign: "center", marginTop: 8 }}>
                        Quantos desse produto?
                    </Typography>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
                        <ButtonGroup>
                            <Button
                                aria-label="reduce"
                                onClick={() => setQtdAdicionar(prev => Math.max(1, prev - 1))}
                                style={{ background: "#dc3545", color: "white" }}
                            >
                                <Remove fontSize="small" />
                            </Button>

                            <TextField
                                type="number"
                                value={qtdAdicionar}
                                onChange={e => {
                                    const v = Number(e.target.value)
                                    if (Number.isFinite(v))
                                        setQtdAdicionar(Math.max(1, Math.floor(v)))
                                }}
                                variant="outlined"
                                size="small"
                                inputProps={{ min: 1, style: { textAlign: "center", width: 70 } }}
                            />

                            <Button
                                aria-label="increase"
                                onClick={() => setQtdAdicionar(prev => prev + 1)}
                                style={{ background: "#28a745", color: "white" }}
                            >
                                <Add fontSize="small" />
                            </Button>
                        </ButtonGroup>
                    </div>

                    {itemAdicionar?.produto?.permiteObservacao ? (
                        <>
                            <Typography style={{ textAlign: "center", marginTop: 16 }}>
                                Alguma observação?
                            </Typography>

                            <TextField
                                style={{ marginTop: 12 }}
                                variant="outlined"
                                fullWidth
                                label="Observação"
                                value={obsAdicionar}
                                onChange={e => setObsAdicionar(e.target.value)}
                            />
                        </>
                    ) : null}
                </DialogContent>

                <DialogActions>
                    <Button
                        style={{ color: "white", backgroundColor: "#dc3545" }}
                        onClick={fecharDialogAdicionar}
                    >
                        Cancelar
                    </Button>

                    <Button
                        style={{ color: "white", backgroundColor: "#28a745" }}
                        onClick={() =>
                            handleAdicionarItem(itemAdicionar, qtdAdicionar, obsAdicionar)
                        }
                        disabled={!itemAdicionar}
                    >
                        Adicionar
                    </Button>
                </DialogActions>
            </Dialog>

            <div className={classes.cardPedido}>
                <div className={classes.tituloPedido}>
                    <Typography>
                        {index + 1}º {pedidoEnviar?.cliente?.nome}
                    </Typography>
                    <Typography>{formatBRL(resumo.valorTotalProdutos)}</Typography>
                </div>
                <div className={classes.cardItens}>
                    {itens?.map((item, index) => (
                        <Paper
                            key={`${index + item?.id + Date.now()}`}
                            className={classes.paperCardPedido}
                        >
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid
                                    item
                                    xs={8}
                                    sm={9}
                                    md={9}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "1em",
                                        fontWeight: "bold",
                                    }}
                                >
                                    <Typography variant="h6">{item?.quantidade}x</Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Typography>{item?.produto?.nome}</Typography>
                                        <Typography variant="caption">
                                            Total: R$ {formatBRL(item?.valorProdutoHistorico)}
                                        </Typography>
                                    </div>
                                </Grid>
                                {EXIBIR_DELETE && item.produto.opcoes.length <= 1 ? (
                                    <Grid
                                        item
                                        xs={4}
                                        sm={3}
                                        md={3}
                                        container
                                        justifyContent="flex-end"
                                    >
                                        <IconButton onClick={() => abrirDialogAdicionar(item)}>
                                            <Add />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => {
                                                setItemExcluir(item)
                                                handleToggleDialogExcluir()
                                            }}
                                        >
                                            <Remove />
                                        </IconButton>
                                    </Grid>
                                ) : EXIBIR_DELETE ? (
                                    <IconButton
                                        onClick={() => {
                                            setItemExcluir(item)
                                            handleToggleDialogExcluir()
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                ) : null}
                            </Grid>
                        </Paper>
                    ))}
                </div>
                <div className={classes.actionsCardPedidos}>
                    <Button
                        onClick={() =>
                            history.push(
                                "/servicos/modulo/registrador-de-pedidos?mesa=" +
                                    mesa.numeroMesa +
                                    "&idPedido=" +
                                    pedidoEnviar.id
                            )
                        }
                        style={{ color: "white", backgroundColor: "#28a745", opacity: "0.9" }}
                    >
                        Adicionar Item
                    </Button>
                </div>
            </div>
        </>
    )
}
export default CardPedido
